<template>
  <v-dialog v-model="dialogOpen" width="500" persistent>
    <v-card>
      <v-card-title>Edit Provisioning Details</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-menu v-model="futureLiveDateMenu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="futureLiveDate" label="Future Live Date" readonly v-bind="attrs" v-on="on" dense outlined>
                    <v-icon slot="append" color="error" v-if="futureLiveDate" @click="futureLiveDate=null">close</v-icon>
                  </v-text-field>
              </template>
              <v-date-picker v-model="futureLiveDate" @input="futureLiveDateMenu = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="submitLoading" :loading="submitLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState,mapActions } from 'vuex';
  export default {
    props: ['dialogOpen'],
    data() {
      return {
        submitLoading: false,
        futureLiveDate: '',
        futureLiveDateMenu: false,
      }
    },
    computed: {
      ...mapState('products',['currentProduct']),
    },
    watch: {
      dialogOpen(open) {
        if(open){
          this.futureLiveDate = this.currentProduct.future_live_date;
        }
      }
    },
    methods: {
      ...mapActions('products',['updateProductData']),
      async submit() {
        this.submitLoading = true;
        let data = {future_live_date:(this.futureLiveDate===''||this.futureLiveDate===undefined)?null:this.futureLiveDate}
        await this.updateProductData({id:this.currentProduct.id,data:data});
        this.submitLoading = false;
        this.close();
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
